export default __webpack_public_path__ + "static/media/ritual2.6bea7ef0.png";